import { css } from '@emotion/react';
import { Select } from 'components/Select';
import { OrganizationEmailType, useUpsertOrganizationEmailMutation } from 'generated/graphql';
import { Controller, useForm } from 'react-hook-form';
import { emailTypeOptions } from '../emailTypeLabel';
import { useStore } from 'hooks/useStore';
import { Button } from 'components/Button';
import { IconDone } from 'components/ProcessStep';
import { IconPlus } from 'icons/Plus';
import { IconCross } from 'icons/icon-cross';
import { emailValidation } from 'screens/booking/forms/validations';
import { theme } from 'styles/theme';

export const ItemForm = ({ item, onClose }: { item?: any; onClose: () => void }) => {
	const [{ fetching }, upsertOrganizationEmail] = useUpsertOrganizationEmailMutation();
	const id = item?.id;

	const { notifications } = useStore();

	const {
		register,
		handleSubmit,
		formState: { errors, isDirty },
		watch,
		control,
		reset,
	} = useForm({
		defaultValues: {
			email: item?.email,
			type: item?.type ?? OrganizationEmailType.EmailTo,
		},
	});

	const onSubmit = (data) => {
		upsertOrganizationEmail({
			id: id ?? null,
			input: { ...data },
		}).then((result) => {
			if (!result.error) {
				notifications.addNotification({ title: '✅ Hotovo', message: 'Email uložen.' });
				onClose();
				reset();
			} else {
				// TODO an error
			}
		});
	};

	watch('email');

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			css={css`
				flex-grow: 1;
				display: flex;
				gap: 8px;
			`}
		>
			<div
				css={css`
					display: flex;
					flex-grow: 1;
				`}
			>
				<div
					css={css`
						display: flex;
						flex-direction: column;
						flex-grow: 1;
					`}
				>
					<div
						css={css`
							display: flex;
							flex-shrink: 0;
							flex-grow: 1;

							border: 1px solid #d4d5de;
							border-radius: 8px;
							background: #fff;

							${!!errors.email &&
							css`
								border-color: #ff6767;
							`}
						`}
					>
						<div
							css={css`
								width: 136px;
								flex-shrink: 0;
							`}
						>
							<Controller
								name="type"
								control={control}
								rules={{ required: 'Vyberte interpreta.' }}
								render={({ field }) => {
									return <Select {...field} options={emailTypeOptions} isCompositePrefix />;
								}}
							/>
						</div>

						<input
							autoFocus={!!id}
							placeholder="@"
							css={css`
								border: 0;
								background: #fff;
								padding-left: 8px;

								width: 100%;

								border-radius: 0 8px 8px 0;

								::placeholder {
									color: #8c8fa6;
								}

								&:focus {
									outline: none;
									box-shadow: 0 0 0 2px ${theme.color.primary['400']};
									border-color: transparent;
								}
							`}
							type="text"
							{...register('email', emailValidation({ required: 'Zadejte e-mail.' }))}
						/>
					</div>

					{errors.email && (
						<div
							css={css`
								width: 100%;
								font-size: 13px;
								line-height: 16px;
								font-weight: 600;
								color: #ff6767;
								padding-top: 8px;
								margin-bottom: 12px;
							`}
						>
							{errors.email.message}
						</div>
					)}
				</div>
			</div>

			<Button type="submit" square disabled={!isDirty} isProcessing={fetching}>
				{item?.id ? <IconDone /> : <IconPlus />}
			</Button>

			{item?.id && (
				<Button onClick={onClose} square isProcessing={fetching} outline>
					<IconCross />
				</Button>
			)}
		</form>
	);
};
